import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeight = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	className: "icon icon-tabler icon-tabler-weight",
	width: 44,
	height: 44,
	viewBox: "0 0 24 24",
	strokeWidth: 1.5,
	stroke: "currentColor",
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.835 9h10.33a1 1 0 0 1 .984 .821l1.637 9a1 1 0 0 1 -.984 1.179h-13.604a1 1 0 0 1 -.984 -1.179l1.637 -9a1 1 0 0 1 .984 -.821z" })
	]
});
export default SvgWeight;
